__turbopack_context__.v({
  "backgroundImage": "AO-KIG_backgroundImage",
  "section": "AO-KIG_section",
  "sectionDescription": "AO-KIG_sectionDescription",
  "sectionHeaderContainer": "AO-KIG_sectionHeaderContainer",
  "sectionHeaderContainerWithBackground": "AO-KIG_sectionHeaderContainerWithBackground",
  "sectionHeaderContentWrap": "AO-KIG_sectionHeaderContentWrap",
  "sectionTitle": "AO-KIG_sectionTitle",
});
